import React, { useState } from 'react';

const initialState = {
  loanType: '',
  eligibilityCriteria: '',
  interestRate: '',
  loanInsurance: '',
  minLoanAmount: '',
  maxLoanAmount: '',
  status: 'Active',
};

const AddLoanModal = ({ isOpen, onClose, onSubmit, insurances = [] }) => {
  const [form, setForm] = useState(initialState);
  const [submitting, setSubmitting] = useState(false);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    await onSubmit(form);
    setSubmitting(false);
    setForm(initialState);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-[#131313] rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-medium">Add Loan Product</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white text-2xl">×</button>
        </div>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">Loan Type</label>
            <input type="text" name="loanType" value={form.loanType} onChange={handleChange} required className="w-full bg-gray-800 border border-[#333333] rounded-md px-3 py-2 text-white" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">Eligibility Criteria</label>
            <input type="text" name="eligibilityCriteria" value={form.eligibilityCriteria} onChange={handleChange} required className="w-full bg-gray-800 border border-[#333333] rounded-md px-3 py-2 text-white" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">Interest Rate (%)</label>
            <input type="number" name="interestRate" value={form.interestRate} onChange={handleChange} min="0" step="0.01" className="w-full bg-gray-800 border border-[#333333] rounded-md px-3 py-2 text-white" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">Linked Insurance</label>
            <select name="loanInsurance" value={form.loanInsurance} onChange={handleChange} className="w-full bg-gray-800 border border-[#333333] rounded-md px-3 py-2 text-white">
              <option value="">None</option>
              {insurances.map((ins, idx) => (
                <option key={idx} value={ins.insurance}>{ins.insurance}</option>
              ))}
            </select>
          </div>
          <div className="flex space-x-2">
            <div className="w-1/2">
              <label className="block text-sm font-medium text-gray-400 mb-1">Min Loan Amount</label>
              <input type="number" name="minLoanAmount" value={form.minLoanAmount} onChange={handleChange} min="0" className="w-full bg-gray-800 border border-[#333333] rounded-md px-3 py-2 text-white" />
            </div>
            <div className="w-1/2">
              <label className="block text-sm font-medium text-gray-400 mb-1">Max Loan Amount</label>
              <input type="number" name="maxLoanAmount" value={form.maxLoanAmount} onChange={handleChange} min="0" className="w-full bg-gray-800 border border-[#333333] rounded-md px-3 py-2 text-white" />
            </div>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-400 mb-1">Status</label>
            <select name="status" value={form.status} onChange={handleChange} className="w-full bg-gray-800 border border-[#333333] rounded-md px-3 py-2 text-white">
              <option value="Active">Active</option>
              <option value="Closed">Closed</option>
            </select>
          </div>
          <div className="flex justify-end space-x-3 mt-6">
            <button type="button" onClick={onClose} className="px-4 py-2 border border-[#333333] rounded-md text-sm hover:bg-gray-800">Cancel</button>
            <button type="submit" disabled={submitting} className="px-4 py-2 bg-[#FFCA20] text-black rounded-md text-sm hover:bg-yellow-600">
              {submitting ? 'Adding...' : 'Add Loan'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddLoanModal; 